import _ from 'lodash';
import * as turf from '@turf/turf';

import {
  FALLBACK_FEATURE_ID,
  FALLBACK_FEATURE_RADIUS,
  MAIN_SOURCE_ID,
  ZOOM_FOR_FALLBACK,
} from './constants';
import { setSourceData } from '../../utils/map';
import { layerIdForTileset } from '../../utils/tilesets';

/**
 * Sorts tilesets by suitability (desc) and then by name (asc) but putting Chestnuts first for name.
 */
export const sortTilesetSuitability = (tilesets) =>
  _.sortBy(tilesets, [(t) => -(t.suitableAcres ?? 0), 'name']);

export const getSelectedFeatures = (map, selectedFeatureIds) => {
  const features = map.querySourceFeatures(MAIN_SOURCE_ID);
  const selectedFeatures = features.filter((feature) =>
    selectedFeatureIds.includes(feature.properties.id),
  );
  return _.uniqBy(selectedFeatures, 'properties.id');
};

/**
 * Add a circle to the map as a baseline
 */
export const addFallbackBoundary = async (
  mapRef,
  toggleFeatureId,
  resetSelectedFeatures,
) => {
  const map = mapRef.current;
  if (!map) throw new Error('Map not loaded');

  const id = FALLBACK_FEATURE_ID;

  map.setZoom(ZOOM_FOR_FALLBACK);

  const { lng, lat } = map.getCenter();
  const { value, units } = FALLBACK_FEATURE_RADIUS;
  const feature = turf.circle([lng, lat], value, {
    units,
    properties: { id },
  });

  const data = turf.featureCollection([feature]);
  await setSourceData(map, MAIN_SOURCE_ID, data);

  // Select the circle
  resetSelectedFeatures();
  toggleFeatureId(id);
};

export const layerForTileset = (map, tilesetId) =>
  map.getLayer(layerIdForTileset(tilesetId))?.implementation;

export const getNonFallbackFeatures = (map) =>
  map
    .querySourceFeatures(MAIN_SOURCE_ID)
    .filter((f) => f.properties.id !== FALLBACK_FEATURE_ID);
